import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import React from 'react';
import {Tooltip} from '@mui/material';

const ToggleCard = ({
  selected,
  children,
  onClick,
  button = true,
  disabled = false,
  showCheckbox = false,
  title = '',
  sx,
  'aria-label': ariaLabel,
  ...props
}) => {
  return (
    <Tooltip title={title}>
      <Card
        component={Box}
        variant="outlined"
        sx={{
          borderColor: selected ? 'primary.main' : 'grey.300',
          bgcolor: selected ? 'primary.lighter' : 'white',
          borderWidth: selected ? 2 : 1,
          flexShrink: 0,
          ...sx,
        }}
        {...props}
      >
        {showCheckbox && (
          <Box position="absolute" top={2} left={2} zIndex={1}>
            <Checkbox
              checked={selected}
              disabled={disabled}
              disableRipple
              style={{padding: 0}}
              onClick={onClick}
            />
          </Box>
        )}
        {button ? (
          <CardActionArea
            disabled={disabled}
            onClick={onClick}
            style={{height: '100%'}}
            aria-label={ariaLabel}
          >
            {children}
          </CardActionArea>
        ) : (
          children
        )}
      </Card>
    </Tooltip>
  );
};

ToggleCard.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  button: PropTypes.bool,
  disabled: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  title: PropTypes.string,
  sx: PropTypes.object,
  'aria-label': PropTypes.string,
};

export default ToggleCard;
